/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface FeatureGroup {
  id: number;
  header: string;
  enabled?: boolean;
  pos?: number;
  isSystem?: boolean;
  deleted?: boolean;
  roles?: FeatureGroupRole[];
  /** PIM2-637 — общая группа: демо-колонка на CORE-таблице `feature_group`, максимум одна `true`. */
  isCommon?: boolean;
}

export interface FeatureGroupRole {
  id: number;
  name: string;
  header: string;
  enabled?: boolean;
  isSystem: boolean;
  deleted: boolean;
}
